<template>
    <div class="Menu">
        <v-snackbar
          :timeout="snackbar.timeout"
          :color="snackbar.color"
          v-model="snackbar.show"
        >
          {{ snackbar.message }}
        </v-snackbar>
        <!-- Laci REL: 56px ikon sahaja, mengembang apabila tetikus di atasnya.

             Kenapa `mini-variant` DAN `expand-on-hover` kedua-duanya diikat:
             VNavigationDrawer.updateApplication() (yang menetapkan padding-left
             <v-main>) membaca prop `miniVariant` — BUKAN `isMiniVariant` yang
             dikira. Jadi dengan miniVariant=true ia sentiasa melaporkan 56px,
             manakala isMiniVariant = !isMouseover mengembangkan lebar VISUAL
             kepada 332px. Hasilnya: menu mengapung DI ATAS halaman semasa hover
             dan kandungan TIDAK teranjak — jika tidak, seluruh halaman akan
             terhentak setiap kali tetikus melintasi menu.

             `expand-on-hover` mesti dimatikan apabila `pinned`: jika tidak
             isMiniVariant = expandOnHover && !isMouseover akan menguncupkan
             semula menu yang sengaja dibuka sebaik tetikus keluar. -->
        <v-navigation-drawer
        app
        v-model="drawer"
        :permanent="railBoleh"
        :temporary="!railBoleh"
        :mini-variant="railBoleh && !pinned"
        :expand-on-hover="railBoleh && !pinned"
        mini-variant-width="56"
        disable-resize-watcher
        width="332"
        class="nav-drawer"
        :class="{ 'nav-drawer--gelap': gelap, 'nav-drawer--diam': !siapBoot }"
        @mouseenter.native="railMasuk"
        @mouseleave.native="railKeluar"
        >
          <!-- Jenama — cerminan panel hero `paparanutama`: kecerunan teal gelap,
               wordmark dengan garis miring mint. Jata kekal kelihatan dalam
               keadaan rel; teks jenama hanya muncul apabila menu mengembang. -->
          <!-- Wordmark teks "HIES/BA" DIBUANG — logo itu sendiri sudah
               mengandungi perkataan HIES dan BA; memaparkan kedua-duanya
               hanyalah pengulangan. -->
          <div class="nav-brand">
            <!-- Jubin PUTIH bersudut bulat mengelilingi logo. 'HIES watermark.png'
                 ialah RGB tanpa saluran alfa — latar putihnya TERBAKAR ke dalam
                 piksel. Dalam mod gelap ia akan tetap muncul sebagai segi empat
                 putih; jubin ini menjadikan segi empat itu satu keputusan reka
                 bentuk yang disengajakan, bukan kecacatan. -->
            <span class="nav-brand__jubin">
              <img class="nav-brand__logo" :src="require('@/assets/HIES watermark.png')" alt="HIES/BA">
            </span>
            <!-- Susunan yang SAMA seperti kepala bar atas — [jenama] │ [tajuk]. -->
            <div class="nav-brand__text">
              <span class="nav-brand__rule"></span>
              <span class="nav-brand__sub">{{$t('(HIES/BA) Analisis')}}</span>
            </div>
            <!-- Suis diletak di HUJUNG baris jenama; `margin-left: auto` menolaknya
                 ke kanan tanpa memerlukan elemen pengisi. -->
            <v-btn icon small class="nav-brand__suis" @click="toggleGelap" :title="tajukGelap">
              <v-icon size="18">{{ gelap ? 'mdi-weather-sunny' : 'mdi-weather-night' }}</v-icon>
            </v-btn>
          </div>

          <div class="nav-eyebrow">{{$t('menu')}}</div>

          <!-- `expand` MESTI ada. Tanpanya VList.listClick() memanggil toggle() pada
               SETIAP kumpulan berdaftar apabila satu kumpulan dibuka, jadi membuka
               kumpulan bersarang (cth. Pendapatan Isi Rumah) akan menutup kumpulan
               INDUKNYA (Jadual Awalan) — submenu terus hilang. Kumpulan bersarang
               mendaftar pada senarai ini kerana provide/inject mengikut pokok
               komponen, dan `.nav-sub` hanyalah <div>, bukan <v-list>.
               Sifat akordion tetap dikawal oleh openGroup/openSubGroup di bawah. -->
          <v-list class="nav-list" nav dense expand>
            <template v-for="(link, i) in navsidebarmenus">
              <!-- pautan tunggal -->
              <v-list-item
                v-if="!link.subLinks"
                :key="link.to || link.text || i"
                class="nav-item"
                :class="{ 'menu-active': isActive(link.to) }"
                @click="pilihUtama(link.to)"
              >
                <v-list-item-icon class="nav-item__icon">
                  <v-icon size="20">{{ link.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="nav-item__title">{{$t(link.text)}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- kumpulan peringkat atas -->
              <v-list-group
                v-else
                :key="link.text || i"
                no-action
                class="nav-group"
                :class="{ 'nav-group--active': linkHasActive(link) }"
                :value="openGroup === link.text"
                @input="v => setOpenGroup(link.text, v)"
              >
                <template v-slot:activator>
                  <v-list-item-icon class="nav-item__icon">
                    <v-icon size="20">{{ link.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="nav-item__title">{{$t(link.text)}}</v-list-item-title>
                  </v-list-item-content>
                </template>

                <!-- Garis panduan menegak menggantikan belasan <v-divider>:
                     hierarki ditunjukkan oleh inden, bukan oleh garis melintang. -->
                <div class="nav-sub">
                  <template v-for="(sublink, si) in link.subLinks">
                    <!-- kumpulan bersarang -->
                    <v-list-group
                      v-if="sublink.subLinks"
                      :key="sublink.text || si"
                      no-action
                      class="nav-group nav-group--nested"
                      :class="{ 'nav-group--active': sublinkHasActive(sublink) }"
                      :value="openSubGroup === sublink.text"
                      @input="v => setOpenSubGroup(sublink.text, v)"
                    >
                      <template v-slot:activator>
                        <v-list-item-icon class="nav-item__icon">
                          <v-icon size="18">{{ sublink.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title class="nav-item__title nav-item__title--sub">{{$t(sublink.text)}}</v-list-item-title>
                        </v-list-item-content>
                      </template>

                      <div class="nav-sub">
                        <v-list-item
                          v-for="child in sublink.subLinks"
                          :key="child.to || child.text"
                          class="nav-item nav-item--leaf"
                          :class="{ 'menu-active': isActive(child.to) }"
                          @click="goToRoute(child.to)"
                        >
                          <v-list-item-icon class="nav-item__icon">
                            <v-icon size="18">{{ child.icon }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title class="nav-item__title nav-item__title--leaf">{{$t(child.text)}}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </div>
                    </v-list-group>

                    <!-- pautan sublink biasa -->
                    <v-list-item
                      v-else
                      :key="sublink.to || sublink.text || si"
                      class="nav-item nav-item--leaf"
                      :class="{ 'menu-active': isActive(sublink.to) }"
                      @click="goToRoute(sublink.to)"
                    >
                      <v-list-item-icon class="nav-item__icon">
                        <v-icon size="18">{{ sublink.icon }}</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="nav-item__title nav-item__title--sub">{{$t(sublink.text)}}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </div>
              </v-list-group>
            </template>
          </v-list>

          <!-- Kad pengguna DUDUK DI BAWAH senarai dalam susunan DOM, bukan
               ditolak ke bawah dengan `margin-top: auto`. Perbezaannya penting:
               dengan margin ia hanya berada di bawah apabila senarai pendek, dan
               menghilang ke bawah lipatan sebaik senarai melimpah. Di sini
               `.nav-list` yang menatal (flex: 1 + min-height: 0), jadi kad ini
               KEKAL berlabuh di dasar laci pada setiap ketinggian skrin.

               `title`: dalam keadaan rel hanya ikon kelihatan, jadi nama
               penuh kekal boleh dicapai melalui tooltip penyemak imbas. -->
          <div class="nav-user" :title="nama ? nama + ' — ' + peranan : ''">
            <div class="nav-user__avatar"><v-icon>mdi-account</v-icon></div>
            <div class="nav-user__text">
              <div class="nav-user__name">{{ nama }}</div>
              <div class="nav-user__role">{{ peranan }}</div>
            </div>
            <!-- Guna semula menuActionClick('logkeluar') dan BUKAN pengendali
                 baharu: laluan itu mengaudit log keluar di backend dan
                 mengekalkan keutamaan menu merentasi localStorage.clear().
                 Menyalinnya di sini bermakna satu daripadanya pasti terlupa
                 apabila logik itu berubah kelak. -->
            <v-btn
              icon
              small
              class="nav-user__keluar"
              :title="$t('logkeluar')"
              @click="menuActionClick('logkeluar')"
            >
              <v-icon size="18">mdi-logout-variant</v-icon>
            </v-btn>
          </div>
        </v-navigation-drawer>

        <v-app-bar
        app
        flat
        dark
        height="60"
        class="app-bar"
        >
          <!-- Slot lalai menggantikan ikon `$menu` VAppBarNavIcon sepenuhnya.
               Ikon pin menjadikan keadaan tersemat itu jelas — jika tidak, ☰
               kelihatan serupa sama ada menu disemat atau tidak. -->
          <v-app-bar-nav-icon @click.stop="toggleMenu" :title="tajukToggle">
            <v-icon>{{ disemat ? 'mdi-pin' : 'mdi-menu' }}</v-icon>
          </v-app-bar-nav-icon>
          <!-- Wordmark bar atas DIBUANG. Ia mengeja "HIES/BA" dan segera
               mengulanginya di dalam tajuk — "HIES/BA │ (HIES/BA) Analisis" —
               jadi jenama itu dibaca dua kali dalam satu baris. Laci sisi
               memikul identiti sistem: logo kekal kelihatan walaupun dalam
               keadaan rel 56px, dan tajuknya muncul apabila menu mengembang. -->
          <v-spacer></v-spacer>
          <!-- Penukar bahasa disembunyikan buat masa ini — sistem BM sahaja.
               Locale dikunci kepada 'bm' dalam main.js router.beforeEach. -->
          <!-- <Switchlang></Switchlang> -->
          <v-menu left bottom offset-y nudge-bottom="6">
            <template v-slot:activator="{ on, attrs }">
              <div class="user-chip" v-bind="attrs" v-on="on">
                <span class="user-chip__avatar"><v-icon size="18">mdi-account</v-icon></span>
                <span class="user-chip__text">
                  <span class="user-chip__name">{{ nama }}</span>
                  <span class="user-chip__role">{{ peranan }}</span>
                </span>
                <v-icon size="18" class="user-chip__chev">mdi-chevron-down</v-icon>
              </div>
            </template>

            <v-list dense class="user-menu">
              <v-list-item
                v-for="headers in senaraiheader"
                :key="headers.title"
                @click="menuActionClick(headers.action)"
              >
                <v-list-item-icon class="user-menu__icon">
                  <v-icon size="18">{{ headers.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="user-menu__title">{{$t(headers.title)}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-app-bar>
        
        <v-dialog
          v-model="dialogkemaskinimaklumatpengguna"
          persistent
          max-width="500px"
        >
          <v-card>
            <v-form ref="formkemaskinimaklumatpengguna">
            <v-card-title>
                <span class="text-h5">{{$t('kemaskinimaklumatpengguna')}}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                      <v-col
                          cols="12"
                      >
                      <v-text-field
                        v-model="semakkemaskiniemel"
                        v-show="false">
                      </v-text-field>
                      <v-text-field
                      outlined dense
                      readonly
                      filled
                      background-color="grey lighten-3"
                      v-model="kemaskiniemel"
                      v-bind:label="$t('emel')"
                      ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                      >
                      <v-text-field
                      outlined dense
                      v-model="kemaskininama"
                      :rules="[required('nama')]"
                      v-bind:label="$t('nama')"
                      ></v-text-field>
                      </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions class="px-6 pb-4">
              <v-spacer></v-spacer>
              <v-btn
                  color="grey darken-1"
                  text
                  @click="dialogkemaskinimaklumatpengguna = false"
              >
               {{$t('tutup')}}
              </v-btn>
              <v-btn
                  color="success"
                  depressed
                  @click="hantarkemaskinipengguna()"
              >
                {{$t('kemaskini')}}
              </v-btn>
            </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
        
        <v-dialog
          v-model="dialogkemaskinikatalaluan"
          persistent
          max-width="500px"
        >
          <v-card>
            <v-form ref="formkemaskinikatalaluan">
            <v-card-title>
                <span class="text-h5">{{$t('kemaskinikatalaluan')}}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-alert
                      dense
                      text
                      type="info"
                      class="mb-4 text-caption"
                      border="left"
                    >
                      <div class="font-weight-medium mb-1">Standard Kata Laluan Minimum</div>
                      <div class="mb-1">
                        <v-icon x-small :color="petunjukPanjang ? 'success' : 'grey'">
                          {{ petunjukPanjang ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                        </v-icon>
                        Panjang minimum {{ MIN_PANJANG_KATALALUAN }} aksara
                      </div>
                      <div>
                        <v-icon x-small :color="bilanganJenisKarakter >= 3 ? 'success' : 'grey'">
                          {{ bilanganJenisKarakter >= 3 ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                        </v-icon>
                        Sekurang-kurangnya 3 daripada 4 jenis berikut ({{ bilanganJenisKarakter }}/4):
                      </div>
                      <div class="pl-6">
                        <span :class="petunjukHurufBesar ? 'success--text' : 'grey--text'">
                          <v-icon x-small :color="petunjukHurufBesar ? 'success' : 'grey'">
                            {{ petunjukHurufBesar ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                          Huruf besar (A-Z)
                        </span>
                        <br>
                        <span :class="petunjukHurufKecil ? 'success--text' : 'grey--text'">
                          <v-icon x-small :color="petunjukHurufKecil ? 'success' : 'grey'">
                            {{ petunjukHurufKecil ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                          Huruf kecil (a-z)
                        </span>
                        <br>
                        <span :class="petunjukNombor ? 'success--text' : 'grey--text'">
                          <v-icon x-small :color="petunjukNombor ? 'success' : 'grey'">
                            {{ petunjukNombor ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                          Nombor (0-9)
                        </span>
                        <br>
                        <span :class="petunjukSimbol ? 'success--text' : 'grey--text'">
                          <v-icon x-small :color="petunjukSimbol ? 'success' : 'grey'">
                            {{ petunjukSimbol ? 'mdi-check' : 'mdi-close' }}
                          </v-icon>
                          Simbol khas (!@#$%^&amp;*)
                        </span>
                      </div>
                    </v-alert>
                    <v-row>
                      <v-col
                          cols="12"
                      >
                      <v-text-field
                      outlined dense
                      v-model="kemaskinikatalaluankatalaluansemasa"
                      v-bind:label="$t('katalaluansemasa')"
                      :rules="[required('katalaluansemasa'), kemaskinikatalaluansemasatidaksama, minkatalaluan]"
                      :messages="msgkemaskinikatalaluansemasatidaksama"
                      :type="paparkatalaluansemasa ? 'text' : 'password'"
                      :append-icon="paparkatalaluansemasa ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="paparkatalaluansemasa = !paparkatalaluansemasa"
                      ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                      >
                      <v-text-field
                      outlined dense
                      v-model="kemaskinikatalaluankatalaluanbaru"
                      v-bind:label="$t('katalaluanbaru')"
                      :rules="[required('katalaluanbaru'), kekuatankatalaluan]"
                      :type="paparkatalaluanbaru ? 'text' : 'password'"
                      :append-icon="paparkatalaluanbaru ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="paparkatalaluanbaru = !paparkatalaluanbaru"
                      ></v-text-field>
                      </v-col>
                      <v-col
                          cols="12"
                      >
                      <v-text-field
                      outlined dense
                      v-model="kemaskinikatalaluanmasukkatalaluanbaru"
                      v-bind:label="$t('masuksemulakatalaluanbaru')"
                      :type="paparkatalaluansemulabaru ? 'text' : 'password'"
                      :append-icon="paparkatalaluansemulabaru ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="paparkatalaluansemulabaru = !paparkatalaluansemulabaru"
                      :rules="[required('masuksemulakatalaluanbaru'), katalaluanbarusama(kemaskinikatalaluankatalaluanbaru,kemaskinikatalaluanmasukkatalaluanbaru)]"
                      ></v-text-field>
                      </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions class="px-6 pb-4">
                <v-spacer></v-spacer>
                <v-btn
                    color="grey darken-1"
                    text
                    @click="dialogkemaskinikatalaluan = false"
                >
                    {{$t('tutup')}}
                </v-btn>
                <v-btn
                    color="success"
                    depressed
                    :disabled="!bolehHantarKatalaluan"
                    @click="hantarkemaskinikatalaluan"
                >
                    {{$t('hantar')}}
                </v-btn>
            </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
    </div>  
</template>
<script>
import axios from '../../plugins/axios'
import navsidebar from '@/model/navsidebar.js'
import { getUserEmail, isUnijayaEmail } from '@/services/emailScope.js'
// import removelocalstorage from '@/services/removelocalstorage.js'
import Switchlang  from "@/components/Switchlang/switchlang"
import i18n from '@/i18n'

/* Keutamaan menu yang kekal merentas sesi. Diawali `menu.` supaya ia jelas
   BUKAN data sesi — lihat juga logkeluar, yang sengaja mengekalkannya. */
const KUNCI_GELAP = 'menu.gelap'
const KUNCI_PINNED = 'menu.pinned'

/* localStorage boleh melempar (mod peribadi Safari, kuki disekat oleh dasar
   korporat). Keutamaan UI tidak layak meruntuhkan menu, jadi kedua-dua arah
   gagal secara senyap dan kembali kepada lalai. */
function bacaKeutamaan(kunci){
  try { return window.localStorage.getItem(kunci) === 'true' } catch(e){ return false }
}
function tulisKeutamaan(kunci, nilai){
  try { window.localStorage.setItem(kunci, String(nilai)) } catch(e){ /* abaikan */ }
}

export default {
  name: 'Menu',
  components: {
    // Switchlang — dinyahdaftar bersama templat yang dikomen di atas.
  },
  data: () => ({
    snackbar: "",
    senaraiheader: [],
    // Standard kata laluan minimum (bukan sistem kritikal -> 8 aksara).
    MIN_PANJANG_KATALALUAN: 8,
    paparkatalaluansemasa: false,
    paparkatalaluanbaru: false,
    paparkatalaluansemulabaru: false,
    kemaskinikatalaluanmasukkatalaluanbarushow: false,
    dialogkemaskinikatalaluan: false,
    dialogkemaskinimaklumatpengguna: false,
    semakemel: false,
    semakkemaskiniemel: '',
    kemaskiniemel: '',
    kemaskininama: '',
    kemaskinikatalaluankatalaluansemasa: '',
    kemaskinikatalaluankatalaluanbaru: '',
    kemaskinikatalaluanmasukkatalaluanbaru: '',
    localstoragename: [],

    msgkemaskiniemel: '',
    kemaskiniemeltidaksama: () => true || this.msgkemaskiniemel,

    msgkemaskinikatalaluansemasatidaksama: '',
    kemaskinikatalaluansemasatidaksama: () => true || this.msgkemaskinikatalaluansemasatidaksama,
    msgkemaskinikatalaluanbarutidaksama: '',
    drawer: false,
    // Rel "disemat": pengguna mengklik ☰ untuk mengunci menu supaya kekal
    // terbuka. Diperlukan kerana peranti sentuh tidak boleh hover langsung.
    // Dimulakan daripada localStorage supaya pilihan kekal selepas muat semula.
    pinned: bacaKeutamaan(KUNCI_PINNED),
    // Mod gelap menu sisi (palet daripada cabang menu-design-2).
    gelap: bacaKeutamaan(KUNCI_GELAP),
    // Palang "susun atur sudah mendap". Selagi false, SEMUA peralihan pada laci
    // dimatikan supaya tiada apa yang beranimasi semasa muat semula halaman.
    siapBoot: false,
    group: null,
    // accordion: only ONE top-level group open at a time (its `text`), and only
    // ONE nested sub-group. Opening another collapses the previous one.
    openGroup: null,
    openSubGroup: null,
    navsidebarmenus: '',
    // pemasa untuk tatal-ke-aktif pada hover rel (lihat railMasuk)
    rafTatal: null,
    nama: '',
    peranan: '',
    header: [
        { title: 'kemaskinimaklumatpengguna', action: "kemaskinimaklumatpengguna"},
        { title: 'kemaskinikatalaluan', action: "kemaskinikatalaluan"},
        { title: 'logkeluar', action: "logkeluar"}     
    ],
    right: null,
    required(text){
      return (v) => 
        (v && v.length > 0) || `${i18n.t(text)} ${i18n.t('adalahdiperlukan')}`
    },
    minkatalaluan: value => {
        return value.length >= 6 || `${i18n.t('minimum')} 6 characters`
    },
    // Rule kekuatan kata laluan baru: panjang minimum + sekurang-kurangnya
    // 3 daripada 4 jenis karakter (huruf besar/kecil, nombor, simbol).
    kekuatankatalaluan(value){
        const v = value || ''
        if(v.length < 8){
          return `${i18n.t('minimum')} 8 aksara`
        }
        const jenis = [/[A-Z]/, /[a-z]/, /[0-9]/, /[^A-Za-z0-9]/]
          .filter(re => re.test(v)).length
        return jenis >= 3 || 'Perlu sekurang-kurangnya 3 daripada 4 jenis karakter'
    },
    katalaluanbarusama(a,b){
        return (a === b) || `${i18n.t('katalaluanbaru')} ${i18n.t('tidakpadan')}` 
    },
    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || `${i18n.t('emeltidaklengkap')}`;
      }
    },
  }),
  computed: {
    // Petunjuk interaktif untuk standard kata laluan minimum (kata laluan baru).
    petunjukPanjang(){
      return (this.kemaskinikatalaluankatalaluanbaru || '').length >= this.MIN_PANJANG_KATALALUAN
    },
    petunjukHurufBesar(){ return /[A-Z]/.test(this.kemaskinikatalaluankatalaluanbaru || '') },
    petunjukHurufKecil(){ return /[a-z]/.test(this.kemaskinikatalaluankatalaluanbaru || '') },
    petunjukNombor(){ return /[0-9]/.test(this.kemaskinikatalaluankatalaluanbaru || '') },
    petunjukSimbol(){ return /[^A-Za-z0-9]/.test(this.kemaskinikatalaluankatalaluanbaru || '') },
    bilanganJenisKarakter(){
      return [this.petunjukHurufBesar, this.petunjukHurufKecil, this.petunjukNombor, this.petunjukSimbol]
        .filter(Boolean).length
    },
    // Butang Hantar hanya aktif bila kata laluan baru memenuhi standard minimum,
    // pengesahan sepadan, dan kata laluan semasa telah diisi.
    bolehHantarKatalaluan(){
      return this.petunjukPanjang
        && this.bilanganJenisKarakter >= 3
        && this.kemaskinikatalaluankatalaluanbaru === this.kemaskinikatalaluanmasukkatalaluanbaru
        && (this.kemaskinikatalaluankatalaluansemasa || '').length > 0
    },
    // Rel hanya masuk akal apabila ada tetikus DAN ruang mendatar. Di bawah `md`
    // ia kembali menjadi laci `temporary` bertindan: 56px yang dicuri daripada
    // skrin telefon terlalu mahal, dan tiada hover untuk mengembangkannya.
    railBoleh(){
      return this.$vuetify.breakpoint.mdAndUp
    },
    // "Benar-benar disemat" — `pinned` sahaja tidak mencukupi: menyematkan menu
    // pada desktop lalu mengecilkan tetingkap ke saiz telefon akan menukar laci
    // kepada `temporary`, dan tanpa pengawal ini jenama bar atas kekal
    // tersembunyi di belakang laci yang sudah tertutup.
    disemat(){
      return this.railBoleh && this.pinned
    },
    tajukToggle(){
      if(!this.railBoleh) return this.$t('menu')
      return this.pinned ? 'Nyahsemat menu' : 'Semat menu'
    },
    tajukGelap(){
      return this.gelap ? 'Menu cerah' : 'Menu gelap'
    },
  },
  beforeMount(){
    this.navsidebar()
  },
  mounted(){
    /* Jaring keselamatan. Peralihan biasanya dihidupkan di hujung navsidebar(),
       tetapi fungsi itu memanggil rangkaian — jika ia gagal atau tergantung,
       laci akan kekal tanpa peralihan SELAMA-LAMANYA dan pengembangan hover
       akan tersentak. Palang ini menjamin ia hidup semula tidak kira apa pun. */
    this.pemasaBoot = setTimeout(() => { this.siapBoot = true }, 1500)

    /* Laci TIDAK PERNAH sepatutnya menatal mendatar. Kandungannya selebar 332px
       di dalam rel 56px, jadi scrollWidth > clientWidth dan apa-apa yang
       menatal secara program (scrollIntoView, fokus papan kekunci pada item
       yang terkerat) akan menganjak keseluruhan menu ke kiri — dan ia kekal
       begitu. Jaring ini menolaknya kembali kepada sifar. */
    this.laciEl = this.$el && this.$el.querySelector('.v-navigation-drawer')
    if(this.laciEl){
      this.tolakTatalMendatar = () => { if(this.laciEl.scrollLeft !== 0) this.laciEl.scrollLeft = 0 }
      this.laciEl.addEventListener('scroll', this.tolakTatalMendatar, { passive: true })
    }
  },
  beforeDestroy(){
    clearTimeout(this.pemasaBoot)
    this.hentiTatal()
    if(this.laciEl && this.tolakTatalMendatar){
      this.laciEl.removeEventListener('scroll', this.tolakTatalMendatar)
    }
  },
  methods:{
    // ☰ bermaksud dua perkara berbeza mengikut susun atur:
    //   rel (desktop) — semat/nyahsemat supaya menu kekal terbuka
    //   telefon       — buka/tutup laci bertindan seperti biasa
    toggleMenu(){
      if(this.railBoleh) this.pinned = !this.pinned
      else this.drawer = !this.drawer
    },
    toggleGelap(){
      this.gelap = !this.gelap
    },
    /* Tatal item aktif ke pandangan — MENEGAK SAHAJA.
       Sengaja BUKAN el.scrollIntoView(). scrollIntoView menatal SETIAP nenek
       moyang yang boleh ditatal pada KEDUA-DUA paksi (`inline` lalai ialah
       'nearest'). Sejak `__content` ditetapkan selebar 332px, laci rel — 56px,
       overflow:hidden — mempunyai scrollWidth 332, dan `overflow: hidden` masih
       boleh ditatal secara PROGRAM. Item aktif bermula pada x~10 dan jauh lebih
       lebar daripada tingkap 56px, jadi 'nearest' menetapkan scrollLeft ~10 —
       dan SEGALA-GALANYA dalam laci teranjak ke kiri sebanyak itu. Ia kekal
       begitu sehingga hover mengembangkan laci kepada 332, di mana clientWidth
       == scrollWidth dan pelayar mengapit scrollLeft kembali kepada 0. Itulah
       "ikon bergerak ke kiri sedikit selepas muat semula, betul semula selepas
       hover". Kekal menegak, dan pepijat itu mustahil berlaku. */
    tatalKeAktif(){
      if(!this.$el) return
      const senarai = this.$el.querySelector('.nav-list')
      const aktif = this.$el.querySelector('.menu-active')
      if(!senarai || !aktif) return
      const rA = aktif.getBoundingClientRect()
      const rS = senarai.getBoundingClientRect()
      // Tinggi 0 = item berada di dalam .nav-sub yang tersembunyi dalam rel.
      if(!rA.height) return false
      senarai.scrollTop += (rA.top - rS.top) - (senarai.clientHeight / 2) + (rA.height / 2)
      return true
    },
    // Cuba menatal pada SETIAP bingkai sehingga geometri wujud, dan bukan
    // menunggu tempoh tetap.
    //
    // Lengah tetap 350ms bermakna pengguna melihat menu mengembang, mendap,
    // dan BARULAH melompat — lompatan itu terasa seperti lag kerana ia berlaku
    // selepas segala-galanya berhenti bergerak. Item bersarang memperoleh
    // tinggi seawal bingkai pertama selepas Vuetify menanggalkan kelas
    // mini-variant, jadi meninjau setiap bingkai menangkap saat paling awal
    // yang mungkin: tatal berlaku SEMASA peralihan kembang, bukan selepasnya,
    // jadi tiada lompatan berasingan untuk dilihat.
    //
    // Had 40 bingkai (~650ms) supaya gelung tidak berjalan selama-lamanya pada
    // halaman yang tiada item menu aktif (cth. Paparan Utama).
    tatalKeAktifBilaSedia(){
      this.hentiTatal()
      let bingkai = 0
      const cuba = () => {
        if(bingkai++ > 40) return
        if(this.tatalKeAktif()) return
        this.rafTatal = requestAnimationFrame(cuba)
      }
      this.rafTatal = requestAnimationFrame(cuba)
    },
    hentiTatal(){
      if(this.rafTatal) cancelAnimationFrame(this.rafTatal)
      this.rafTatal = null
    },
    // Tatal item aktif ke dalam pandangan apabila rel MENGEMBANG kerana hover.
    //
    // Pemerhati `drawer` tidak menangkap kes ini: dengan `expand-on-hover`,
    // pengembangan berlaku SEPENUHNYA di dalam VNavigationDrawer melalui
    // `isMouseover` — `drawer` kekal `true` sepanjang masa bagi laci
    // `permanent`, jadi ia tidak pernah berubah dan pemerhati tidak terpicu.
    //
    // 350ms: dalam keadaan rel, `.nav-sub` disembunyikan, jadi item bersarang
    // mempunyai tinggi 0 dan `tatalKeAktif()` berhenti awal pada semakan
    // `if(!rA.height)`. Peralihan mesti selesai dahulu supaya item mempunyai
    // geometri sebenar untuk diukur.
    railMasuk(){
      // Hanya dalam keadaan rel. Apabila disemat, menu sudah terbuka dan tidak
      // mengembang apa-apa — menatal setiap kali tetikus melintasinya akan
      // menghentak senarai di bawah pengguna yang mungkin sedang menatal sendiri.
      if(!this.railBoleh || this.pinned) return
      this.tatalKeAktifBilaSedia()
    },
    // Tetikus keluar sebelum peralihan selesai: batalkan, jika tidak senarai
    // menatal selepas rel sudah menguncup semula.
    railKeluar(){
      this.hentiTatal()
    },
    async menuActionClick(action){
      switch (action) {
        case "logkeluar":
          // send the token so the backend audits WHO logged out (pengguna, peranan,
          // negeri). The axios interceptor skips the Authorization header for /auth
          // routes, so pass it explicitly as a query param. Read BEFORE clearing storage.
          await axios.get(`${process.env.VUE_APP_API_URL}/auth/logkeluar?token=${window.localStorage.getItem('access_token') || ''}`)
          // this.localstoragename = await removelocalstorage().then()
          //  this.localstoragename.map(function(value) {
          //   window.localStorage.removeItem(`${value}`);
          // });
          // localStorage.clear() memusnahkan SEMUANYA, termasuk keutamaan menu.
          // Keutamaan itu milik peranti, bukan sesi — "ingat mod gelap saya"
          // tidak sepatutnya bermakna "sehingga saya log keluar". Jadi ia
          // disimpan merentasi pembersihan, manakala token/pengguna tetap hilang.
          {
            const keutamaan = [KUNCI_GELAP, KUNCI_PINNED].map(k => [k, window.localStorage.getItem(k)])
            window.localStorage.clear();
            keutamaan.forEach(([k, v]) => { if (v !== null) tulisKeutamaan(k, v === 'true') })
          }
          this.$router.push('/')
          break;
        case "kemaskinikatalaluan":
          this.dialogkemaskinikatalaluan = true
          this.msgkemaskinikatalaluansemasatidaksama = ''
          this.kemaskinikatalaluansemasatidaksama = true
          break;
        case "kemaskinimaklumatpengguna":
          this.dialogkemaskinimaklumatpengguna = true
          try{
            await axios.get(`${process.env.VUE_APP_API_URL}/penggunasistem/paparmaklumatpenggunaid`).then(res=>{
              this.semakkemaskiniemel = res.data.emel
              this.kemaskiniemel = res.data.emel
              this.kemaskininama = res.data.nama
            })
          } catch(err){
            alert(err)
          }
          break;
        default:
          break;
      }
    },
    async navsidebar(){
      const datapengguna = JSON.parse(window.localStorage.getItem('user'))
      this.nama = datapengguna.name
      this.peranan = datapengguna.role
      // Fetch per-user Kawalan Penerbitan permissions (Upload/Semak/Sah). Non-fatal:
      // if it fails the menu just renders without the Kawalan Penerbitan item.
      let penerbitanPerms = []
      try {
        const permRes = await axios.get(`${process.env.VUE_APP_API_URL}/penerbitan/permissions/me`)
        penerbitanPerms = (permRes.data && permRes.data.data && permRes.data.data.permissions) || []
        window.localStorage.setItem('penerbitanPerms', JSON.stringify(penerbitanPerms))
      } catch (e) {
        penerbitanPerms = []
      }
      // Gates "Modul Pengurusan Pengguna" to *.unijaya staff. Falls back to
      // /auth/me for sessions predating email in the login response.
      const emel = await getUserEmail()
      const navsidebarmenu = await navsidebar(datapengguna.role, penerbitanPerms, emel).then()
      //console.log(navsidebarmenu)
      this.navsidebarmenus = navsidebarmenu
      // accordion: open ONLY the group (and nested sub-group) containing the
      // current page. Everything else stays collapsed.
      this.initOpenGroups(navsidebarmenu)
      // Kemaskini Maklumat / Kata Laluan are gated on the same *.unijaya email
      // rule as the Pengurusan Pengguna menu; RESPONDENT never had them. Log
      // keluar stays for everyone — without it a user could not end the session.
      this.senaraiheader = []
      if(this.peranan !== 'RESPONDENT' 
      // && isUnijayaEmail(emel)
      ){
        this.senaraiheader.push(
            { title: 'kemaskinimaklumatpengguna', action: "kemaskinimaklumatpengguna", icon: 'mdi-account-edit-outline'},
            { title: 'kemaskinikatalaluan', action: "kemaskinikatalaluan", icon: 'mdi-lock-reset'}
        )
      }
      this.senaraiheader.push({ title: 'logkeluar', action: "logkeluar", icon: 'mdi-logout-variant'})

      /* Susun atur kini benar-benar mendap: menu dimuatkan dan kumpulan aktif
         telah dibuka. HANYA sekarang peralihan dihidupkan.
         Ia tidak boleh dihidupkan lebih awal — `data-booted` Vuetify sendiri
         menghidupkannya semula pada rAF selepas mounted, iaitu SEBELUM
         permintaan ini selesai, jadi setiap pembetulan susun atur selepas detik
         itu beranimasi. Itulah "slide" pada setiap muat semula. */
      this.$nextTick(() => {
        clearTimeout(this.pemasaBoot)
        this.siapBoot = true
        // Muat pertama: jika menu dibuka (disemat daripada keutamaan tersimpan,
        // atau susun atur mudah alih), bawa item aktif ke dalam pandangan.
        // Tiada pemerhati menangkap ini — `drawer` kekal `true` sepanjang masa
        // bagi laci `permanent`, jadi ia tidak pernah "berubah" untuk dipantau.
        if(this.pinned || !this.railBoleh) this.tatalKeAktifBilaSedia()
      })
    },
    /* Item peringkat atas TANPA sub — cth. Paparan Utama, Julat Harga,
       Konfigurasi. Menutup mana-mana kumpulan yang terbuka: pengguna kini
       berada di halaman yang tiada kaitan langsung dengan kumpulan itu, jadi
       membiarkannya terkembang hanya meninggalkan menu panjang yang terbuka
       kepada cawangan yang sudah tidak relevan.

       Sengaja HANYA untuk peringkat atas. Anak di DALAM kumpulan (Kadar Respon,
       Bekalan Air, ...) masih memakai goToRoute terus — menutup kumpulan di situ
       akan meruntuhkan menu betul-betul di bawah pengguna sebaik mereka
       menavigasi ke dalamnya, dan menyembunyikan halaman aktif mereka sendiri. */
    pilihUtama(url){
      this.openGroup = null
      this.openSubGroup = null
      this.goToRoute(url)
    },
    goToRoute(url){
      this.$router.push(`/${i18n.locale}/${url}`, () => {})
    },
    // highlight the menu item whose `to` matches the current route's last segment
    isActive(to){
      if(!to) return false
      const seg = this.$route.path.split('/').filter(Boolean).pop()
      return seg === to
    },
    // does a nested sublink (or its children) contain the active route?
    sublinkHasActive(sublink){
      if(sublink.subLinks) return sublink.subLinks.some(c => this.isActive(c.to))
      return this.isActive(sublink.to)
    },
    // does a top-level group (or any descendant) contain the active route?
    linkHasActive(link){
      if(!link.subLinks) return this.isActive(link.to)
      return link.subLinks.some(s => this.sublinkHasActive(s))
    },
    // accordion toggle for a top-level group: opening one collapses any other.
    // `v` is Vuetify's new open state — true = expand this group, false = it closed.
    setOpenGroup(text, v){
      this.openGroup = v ? text : (this.openGroup === text ? null : this.openGroup)
    },
    // accordion toggle for a nested sub-group (independent accordion scope)
    setOpenSubGroup(text, v){
      this.openSubGroup = v ? text : (this.openSubGroup === text ? null : this.openSubGroup)
    },
    // seed the accordion from the active route: expand only the group + nested
    // sub-group on the path to the current page. Runs once on load.
    initOpenGroups(menus){
      let group = null
      let subGroup = null
      ;(menus || []).forEach(link => {
        if(!link.subLinks) return
        if(this.linkHasActive(link)) group = link.text
        link.subLinks.forEach(sub => {
          if(sub.subLinks && this.sublinkHasActive(sub)) subGroup = sub.text
        })
      })
      // Halaman semasa TIADA dalam mana-mana kumpulan (Paparan Utama, Julat
      // Harga, Wajaran — item aras atas yang rata). Biarkan accordion seperti
      // sedia ada dan bukan meruntuhkannya: pengguna mungkin telah membuka satu
      // kumpulan untuk melihat isinya, dan menutupnya di sini bermakna setiap
      // lawatan ke halaman rata memadam kerja meneroka itu. Tiada apa yang
      // mengelirukan kekal terbuka — tanda `nav-group--active` dikira daripada
      // laluan, jadi kumpulan itu terbuka TANPA ditanda aktif.
      if(!group) return
      this.openGroup = group
      this.openSubGroup = subGroup
    },
    async hantarkemaskinikatalaluan(){
        if(this.$refs.formkemaskinikatalaluan.validate()){
          const datakemaskinikatalaluan = {
            'kemaskinikatalaluankatalaluansemasa': this.kemaskinikatalaluankatalaluansemasa,
            'kemaskinikatalaluankatalaluanbaru': this.kemaskinikatalaluankatalaluanbaru,
            'kemaskinikatalaluanmasukkatalaluanbaru': this.kemaskinikatalaluanmasukkatalaluanbaru
          }
          const datakemaskini = await axios.post(`${process.env.VUE_APP_API_URL}/penggunasistem/tetapkansemulakatalaluanmanual`, datakemaskinikatalaluan)
          console.log(datakemaskini.data.status)
          if(datakemaskini.data.status){
            this.snackbar = {
                message: i18n.t("berjaya"),
                timeout: 2000,
                color: "success",
                show: true,
            };
            this.dialogkemaskinikatalaluan = false
            this.kemaskinikatalaluankatalaluansemasa = ''
            this.kemaskinikatalaluankatalaluanbaru = ''
            this.kemaskinikatalaluanmasukkatalaluanbaru = ''
            this.$refs.formkemaskinikatalaluan.resetValidation()
            // this.$refs.formkemaskinikatalaluan.reset()
          }
        }
    },
    async hantarkemaskinipengguna(){
        if(this.$refs.formkemaskinimaklumatpengguna.validate()){
          try{
            if(this.semakkemaskiniemel !== this.kemaskiniemel){
              this.semakemel = true
            }
            const datapengguna = {
              semakkemaskiniemel: this.semakemel,
              kemaskiniemel: this.kemaskiniemel,
              kemaskininama: this.kemaskininama
            }
            await axios.post(`${process.env.VUE_APP_API_URL}/penggunasistem/kemaskininamaemelpengguna`, datapengguna).then(res => {
              console.log(res.data.status)
              if(res.data.status){
                this.$refs.formkemaskinimaklumatpengguna.reset()
                this.$store.dispatch('setSnackbar', {
                    showing: true,
                    text: `${i18n.t('berjaya')} ${i18n.t('kemaskini')}`,
                    timeout: 2000
                })
                this.dialogkemaskinimaklumatpengguna = false
                // The email just changed, and it gates the Pengurusan Pengguna
                // group — rebuild the menu now instead of leaving the old one up
                // until the next page load.
                this.navsidebar()
              } else {
                this.$store.dispatch('setSnackbar', {
                    showing: true,
                    text: i18n.t('emelsudahwujud'),
                    timeout: 2000
                })
              }
            })
          } catch(err){
            alert(err)
          }
        }
    }
  },
  watch: {
    // Buka semula accordion pada SETIAP perubahan laluan.
    //
    // `initOpenGroups()` dipanggil sekali sahaja ketika menu dimuatkan, dan
    // MenuHeader ialah komponen susun atur yang KEKAL — navigasi melalui
    // vue-router tidak menciptanya semula. Jadi apabila pengguna sampai ke
    // sesuatu halaman melalui mana-mana laluan selain menu itu sendiri (pautan
    // Akses Pantas di Paparan Utama, butang dalam halaman, URL terus, butang
    // kembali pelayar), kumpulan yang mengandungi halaman itu kekal tertutup —
    // pengguna tiada petunjuk di mana dia berada dalam struktur menu.
    //
    // Kelas `nav-group--active` sudah pun reaktif kerana ia dikira daripada
    // `$route`; yang tidak pernah dikemas kini ialah keadaan BUKA/TUTUP.
    //
    // Menyemai semula juga menutup kumpulan lain yang dibuka pengguna secara
    // manual. Itu memang perilaku accordion yang dikehendaki di sini: menu
    // sepatutnya menunjukkan SATU laluan — laluan ke halaman semasa.
    $route(){
      if(!Array.isArray(this.navsidebarmenus)) return
      this.initOpenGroups(this.navsidebarmenus)
      // Membuka kumpulan tidak mencukupi apabila ia berada di bawah paras
      // pandangan — pengguna nampak menu yang tidak berubah.
      this.$nextTick(() => { this.tatalKeAktifBilaSedia() })
    },
    // Simpan pada perubahan dan bukan di dalam pengendali klik: `pinned` juga
    // berubah melalui laluan lain, dan pemerhati menangkap kesemuanya.
    gelap(val){ tulisKeutamaan(KUNCI_GELAP, val) },
    pinned(val){
      tulisKeutamaan(KUNCI_PINNED, val)
      // Menyemat membuka menu secara kekal, jadi item aktif mesti dibawa ke
      // dalam pandangan — masalah yang sama seperti hover rel, tetapi
      // `railMasuk` sengaja keluar awal apabila disemat (hover pada menu yang
      // SUDAH terbuka tidak sepatutnya menghentak senarai). Menyahsemat tidak
      // perlu menatal: menu menguncup kembali menjadi ikon sahaja.
      if(val) this.$nextTick(() => { this.tatalKeAktifBilaSedia() })
    },
    async kemaskinikatalaluankatalaluansemasa(val){
      if(val.length >= 8){
        console.log(`semak katalaluan`)
        const semakkatalaluan = {
            'semakkatalaluansemasa': val
        }
        const hasilsemak = await axios.post(`${process.env.VUE_APP_API_URL}/penggunasistem/semakkatalaluanpengguna`, semakkatalaluan)
        console.log(hasilsemak.data.status)
        if(!hasilsemak.data.status){
            this.msgkemaskinikatalaluansemasatidaksama = i18n.t('katalaluantidakbetul')
            this.kemaskinikatalaluansemasatidaksama = false
        } else {
            this.msgkemaskinikatalaluansemasatidaksama = ''
            this.kemaskinikatalaluansemasatidaksama = true
        }
      }
    },
    async kemaskiniemel(val){
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(pattern.test(val)){
        if(val !== this.semakkemaskiniemel){
            const keputusansemakemel = await axios.post(`${process.env.VUE_APP_API_URL}/penggunasistem/semakemel`, {semakemel:val})
            if(!keputusansemakemel.data.status){
                this.msgkemaskiniemel = i18n.t('emelsudahwujud')
                this.kemaskiniemeltidaksama = false
            } else {
                this.msgkemaskiniemel = ''
                this.kemaskiniemeltidaksama = true
            }
        }
      }
    },
    group () {
      this.drawer = false
    },
    // apabila laci dibuka, tatal item aktif ke dalam pandangan
    drawer(open){
      if(!open) return
      this.$nextTick(() => { this.tatalKeAktifBilaSedia() })
    },
  },
};
</script>

<style scoped>
/* Palet dikongsi dengan `paparanutama` dan <PageHeader> supaya menu, bar atas
   dan halaman kelihatan sebagai satu sistem, bukan tiga reka bentuk berasingan. */
.Menu {
  --teal-900: #01463e;
  --teal-800: #026254;
  --teal-700: #037769;
  --teal-600: #048374;
  --teal-400: #0EA5A4;
  --mint: #7fe9dd;
  --wash: #eef8f6;
  --hair: #dbeeeb;
}

/* ============================ BAR ATAS ============================ */
/* Kecerunan sama dengan panel hero `paparanutama`. `!important` diperlukan —
   v-app-bar menetapkan latarnya sendiri melalui prop `color`. */
.app-bar {
  background: linear-gradient(120deg, #01463e 0%, #026254 46%, #048374 100%) !important;
  border-bottom: 1px solid rgba(127, 233, 221, .22) !important;
}

/* ---------- Cip pengguna (dahulu: teks mentah + butang tiga titik) ---------- */
.user-chip {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 40px;
  padding: 0 6px 0 6px;
  margin-left: 4px;
  border-radius: 999px;
  cursor: pointer;
  transition: background-color .18s ease;
}
.user-chip:hover {
  background: rgba(255, 255, 255, .10);
}
.user-chip__avatar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(127, 233, 221, .18);
  border: 1px solid rgba(127, 233, 221, .45);
  color: var(--mint);
}
.user-chip__avatar .v-icon {
  color: var(--mint) !important;
}
.user-chip__text {
  display: flex;
  flex-direction: column;
  line-height: 1.15;
  min-width: 0;
}
.user-chip__name {
  font-size: var(--fs-sm);
  font-weight: 600;
  color: #ffffff;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* Peranan sebagai label kecil huruf besar — sepadan `.hero__meta dt`. */
.user-chip__role {
  font-size: var(--fs-3xs);
  font-weight: 600;
  letter-spacing: .9px;
  text-transform: uppercase;
  color: var(--mint);
}
.user-chip__chev {
  color: rgba(255, 255, 255, .55) !important;
}
/* Skrin sempit: avatar sahaja. */
@media (max-width: 599px) {
  .user-chip__text,
  .user-chip__chev {
    display: none;
  }
}

/* Nilai literal, BUKAN var(--teal-700): Vuetify memindahkan kandungan v-menu ke
   akar aplikasi, di luar `.Menu`, jadi pembolehubah CSS di sana tidak terurai. */
.user-menu__icon {
  margin-right: 12px !important;
  align-self: center;
}
.user-menu__icon .v-icon {
  color: #037769 !important;
}
.user-menu__title {
  font-size: var(--fs-md);
  font-weight: 500;
}

/* ============================ LACI MENU ============================ */
/* `overflow: hidden` di sini memindahkan tugas menatal daripada bekas ini
   kepada `.nav-list` di bawah. Itulah yang melabuhkan jenama di atas dan kad
   pengguna di bawah: hanya senarai di antaranya yang menatal. Lalai Vuetify
   ialah `overflow-y: auto` pada elemen ini — jika dibiarkan, SELURUH lajur
   menatal dan kad pengguna hanyut keluar dari pandangan. */
.nav-drawer ::v-deep .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
}
/* Vuetify menghantar `.v-navigation-drawer .v-list:not(.v-select-list)
   { background: inherit }`, jadi senarai MEWARISI latar `__content` dan
   MENGECATNYA SEMULA di atas kotaknya sendiri. Senarai lebih tinggi daripada
   laci (ia menatal), jadi salinan kecerunannya berjalan pada skala berbeza —
   dan di tempat senarai tamat, kecerunan `__content` sambung semula pada fasa
   yang lain. Hasilnya satu garis warna melintang di bawah item terakhir.

   Dalam mod cerah `__content` ialah putih solid, jadi mengecat semula warna
   solid di atas kotak lain tidak kelihatan — itulah sebabnya pepijat ini hanya
   muncul dalam mod gelap. Penyelesaiannya: hanya SATU elemen boleh mengecat
   latar; senarai mesti lut sinar sepenuhnya.

   Kekhususan: peraturan Vuetify ialah (0,3,0). Rantai ini (0,4,0) mengatasinya
   tanpa perlu !important. */
.nav-drawer ::v-deep .v-navigation-drawer__content > .v-list {
  background: transparent;
}

/* Kepala jenama — panel teal gelap, sama seperti hero.

   TINGGI 60px + sempadan yang SAMA dengan <v-app-bar> bukan kebetulan: laci
   tidak `clipped`, jadi computedTop = 0 dan ia bermula di bahagian paling atas
   manakala bar aplikasi bermula di SEBELAH KANANnya. Kedua-duanya memakai
   box-sizing: border-box (html), jadi tinggi 60px MERANGKUMI sempadan 1px itu —
   garis kepala menu dan garis bar atas mendarat pada piksel yang sama dan
   menjadi SATU garis melintasi skrin. Tukar tinggi bar atas -> tukar ini juga. */
.nav-brand {
  /* `flex: 0 0 auto` WAJIB, bukan pembersihan kosmetik. `__content` ialah bekas
     flex lajur setinggi 100%, dan anak flex lalainya `flex-shrink: 1` — jadi
     sebaik kandungan melebihi laci (menu disemat, kumpulan terkembang) blok ini
     DIMAMPATKAN, bukannya menatal. Tinggi 60px runtuh, dan garis kepala tidak
     lagi sebaris dengan bar atas. Dalam keadaan rel `.nav-sub` tersembunyi, jadi
     senarai pendek, tiada limpahan, tiada pemampatan — itulah sebabnya pepijat
     ini hanya menampakkan diri apabila disemat. */
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 60px;
  /* padding-left 8 + jubin 40/2 = 28 = tengah rel 56px. Lihat blok REL di
     bawah: jubin, avatar dan ikon menu KESEMUANYA berpusat pada x=28, jadi
     tiada satu pun bergerak ketika laci mengembang. */
  padding: 0 8px;
  border-bottom: 1px solid var(--hair);
  background: #ffffff;
}
/* Jubin putih bersudut bulat — kekal putih dalam KEDUA-DUA mod. Dalam mod cerah
   ia tidak kelihatan (putih atas putih); dalam mod gelap ia menjadi kad logo. */
.nav-brand__jubin {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Lebar 40 dipilih oleh matematik penjajaran rel, bukan rasa: dengan
     padding-left 8 pada .nav-brand ia berpusat tepat pada x=28. */
  width: 40px;
  height: 40px;
  padding: 2px 3px;
  border-radius: 8px;
  background: #ffffff;
}
/* `object-fit: contain` WAJIB: sumbernya 1976x1586 (landskap 1.25:1). Tanpanya
   imej diregang mengikut kotak dan logo menjadi herot. */
.nav-brand__logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.nav-brand__suis {
  flex: 0 0 auto;
  margin-left: auto;
  color: #7aa8a2 !important;
}
/* Membungkus garis + tajuk BERSAMA bermakna peraturan rel sedia ada yang
   menyembunyikan `.nav-brand__text` turut menyembunyikan garis itu — tiada
   peraturan mini tambahan diperlukan, dan tiada garis tergantung dalam rel. */
.nav-brand__text {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.nav-brand__rule {
  flex: 0 0 auto;
  width: 1px;
  height: 20px;
  background: var(--hair);
}
/* `.nav-brand__mark` / `__slash` dibuang bersama wordmark teks — logo itu
   sendiri sudah mengeja HIES dan BA. */
/* Teal jenama + tebal. Warna jenama PEKAT (#037769) dan bukan nada kelabu-teal
   yang senyap: pada panel putih ini tajuklah satu-satunya teks, jadi ia mampu
   memikul warna penuh tanpa bersaing dengan apa-apa.
   #037769 di atas putih = 5.46:1, lulus WCAG AA dengan selesa. */
.nav-brand__sub {
  font-size: var(--fs-lg);
  font-weight: 700;
  /* `overflow: hidden` di sini diperlukan (ellipsis pada laci sempit), jadi
     kotak baris mesti cukup tinggi untuk kaki huruf menjunam — lihat nota pada
     `.nav-item__title`. Tanpa line-height ini, ekor "g" dalam "Analisis
     Bancian"/tajuk lain terpotong pada 18px. */
  line-height: 1.4;
  color: var(--teal-700);
  letter-spacing: .2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* `flex: 0 0 auto` atas sebab yang sama seperti .nav-brand — jika tidak, kad
   pengguna turut dimampatkan apabila senarai melimpah. */
/* `border-TOP`, bukan bottom: kad ini kini berada di DASAR laci, jadi garis
   pemisahnya mesti berada di antara senarai dan kad — iaitu di atasnya. */
.nav-user {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 9px;
  background: var(--wash);
  border-top: 1px solid var(--hair);
}
.nav-user__avatar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: var(--teal-700);
  color: #ffffff;
}
.nav-user__avatar .v-icon {
  color: #ffffff !important;
}
.nav-user__text {
  min-width: 0;
}
/* `margin-left: auto` menolaknya ke hujung baris. Pada lebar tetap 332px ia
   duduk jauh melepasi rel 56px, jadi ia terkerat (dan tidak boleh diklik)
   ketika menu menguncup — sama seperti suis mod gelap. Log keluar kekal
   dicapai melalui menu akaun pada bar atas. */
.nav-user__keluar {
  flex: 0 0 auto;
  margin-left: auto;
  color: #7aa8a2 !important;
}
.nav-user__keluar:hover {
  color: var(--teal-700) !important;
}
.nav-user__name {
  font-size: var(--fs-md);
  font-weight: 700;
  color: var(--teal-900);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.nav-user__role {
  margin-top: 2px;
  font-size: var(--fs-3xs);
  font-weight: 600;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #4a8a84;
}

/* Label seksyen — menggantikan tajuk "Menu" bersaiz text-h6. */
.nav-eyebrow {
  flex: 0 0 auto;
  padding: 16px 20px 6px;
  font-size: var(--fs-2xs);
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #7aa8a2;
}

/* Rantau yang menatal. `min-height: 0` WAJIB dan bukan berlebihan: anak flex
   mempunyai min-height AUTO, yang enggan mengecut lebih kecil daripada
   kandungannya — jadi senarai akan mengembang setinggi 9 seksyennya dan
   menolak kad pengguna keluar dari dasar laci, dan `overflow-y` tidak akan
   pernah bertindak. Menetapkannya kepada 0 membenarkan senarai mengecut dan
   menatal secara dalaman. */
.nav-list {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  /* `overflow-x: hidden` WAJIB dinyatakan, bukan dibiarkan lalai. CSS mengira
     `visible` menjadi `auto` sebaik paksi yang satu lagi boleh menatal — jadi
     `overflow-y: auto` seorang diri secara senyap memberi paksi-x `auto` juga.
     Dalam rel 56px tajuk item ialah `nowrap` dan jauh lebih lebar daripada 56px,
     maka bar tatal MENDATAR muncul di dasar senarai, betul-betul di atas kad
     pengguna. `__content` Vuetify menetapkan `overflow-x: hidden` atas sebab
     yang sama; tugas menatal berpindah ke sini, jadi peraturan itu perlu ikut. */
  overflow-x: hidden;
  padding: 0 10px 20px;
}

/* ---------- Item menu ----------
   Dahulu: font 20px + <v-divider> selepas SETIAP item. Sekarang saiz menurun
   ikut kedalaman (--fs-lg → --fs-ml → --fs-base, iaitu 18 → 17 → 16px) dan
   hierarki dibawa oleh inden + garis panduan, jadi senarai boleh dibaca
   sebagai satu imbasan. Takuk penuh 1px antara aras, bukan 0.5px: beza
   separuh piksel tidak dilihat mata, cuma menambah nilai untuk disenggara.

   18px pada aras atas ialah permintaan langsung — teks menu sebelum ini
   dianggap terlalu kecil selepas revamp. Perhatikan kesannya: pada lebar laci
   332px, tajuk panjang seperti "Purata & Penengah mengikut Daerah Pentadbiran
   & Strata" kini membalut kepada lebih banyak baris. Itu dibenarkan dengan
   sengaja (`white-space: normal` + `min-height`, bukan tinggi tetap), jadi
   item membesar dan bukannya terkerat. */
.nav-list ::v-deep .v-list-item {
  min-height: 40px;
  border-radius: 8px;
  margin-bottom: 2px;
  transition: background-color .16s ease;
}
.nav-list ::v-deep .v-list-item:hover::before {
  opacity: 0;
}
.nav-list ::v-deep .v-list-item:hover {
  background: var(--wash);
}
.nav-item__icon {
  margin: 8px 12px 8px 0 !important;
  align-self: center;
}
.nav-item__icon .v-icon {
  color: #5d8f8a;
}
.nav-item__title {
  font-size: var(--fs-lg) !important;
  font-weight: 500;
  /* 1.45, bukan 1.35: Vuetify menetapkan `overflow: hidden` pada
     `.v-list-item__title`, jadi kotak baris MENGERAT apa sahaja yang terkeluar
     daripadanya. Pada 18px, kotak baris 1.35 (24.3px) terlalu ketat untuk kaki
     huruf menjunam — ekor "g", "y", "p" dalam "Julat Harga", "Pengurusan",
     "Bulanan Purata" terpotong di bawah. Ia tidak kelihatan pada 14px kerana
     kotak baris yang lebih kecil masih meninggalkan ruang lega yang cukup.

     `overflow: visible` di bawah membatalkan pengeratan itu terus — kita
     membalut teks (`white-space: normal`), jadi tiada ellipsis untuk dijaga
     dan tiada sebab untuk mengerat apa-apa. Kedua-duanya dikekalkan: yang satu
     memberi ruang, yang satu lagi memastikan tiada pengeratan walaupun sesuatu
     mewarisi line-height yang lebih ketat kemudian. */
  line-height: 1.45;
  color: #21403c;
  white-space: normal;
  word-break: break-word;
  overflow: visible;
}
.nav-item__title--sub {
  font-size: var(--fs-ml) !important;
}
.nav-item__title--leaf {
  font-size: var(--fs-base) !important;
  font-weight: 400;
}

/* Cevron kumpulan */
.nav-group ::v-deep .v-list-group__header__append-icon .v-icon {
  font-size: var(--fs-xl);
  color: #9dbdb9;
}
/* Kumpulan yang mengandungi halaman semasa: tanda halus supaya laluan ke
   halaman aktif kekal jelas walaupun kumpulan itu ditutup. */
.nav-group--active ::v-deep .v-list-group__header .nav-item__title {
  color: var(--teal-700);
  font-weight: 700;
}
.nav-group--active ::v-deep .v-list-group__header .nav-item__icon .v-icon {
  color: var(--teal-700);
}

/* Garis panduan menegak — hierarki tanpa <v-divider>. */
.nav-sub {
  position: relative;
  padding-left: 14px;
  margin: 2px 0 6px 12px;
  border-left: 1px solid var(--hair);
}
/* Vuetify menambah inden 72px pada anak `no-action`; kita sudah menginden
   melalui `.nav-sub`, jadi buang supaya teks tidak terhimpit ke tepi kanan. */
.nav-list ::v-deep .v-list-group--no-action > .v-list-group__items > .v-list-item {
  padding-left: 12px;
}

/* ---------- Item aktif ----------
   Warna SAHAJA (tiada jalur tepi kiri), tetapi ISIAN PEKAT, bukan tint.

   Kenapa terus kepada teal pekat dan bukan sekadar tint yang lebih gelap:
   tanpa jalur tepi, latar ialah SATU-SATUNYA isyarat, jadi ia mesti menang
   pada pandangan pertama. Tint pertengahan pula gagal dua kali — ia masih
   senyap, DAN teks teal #037769 di atasnya jatuh ke ~3.9:1 (bawah WCAG AA).
   Putih atas #037769 = 5.46:1, jadi isian pekat sebenarnya LEBIH mudah dibaca
   berbanding tint yang lebih gelap.

   Bonus: dalam keadaan rel 56px, baris aktif menjadi blok teal penuh — halaman
   semasa kekal dapat dikenali walaupun menu menguncup.

   `!important` masih wajib: peraturan :hover di atas dikompil dengan kekhususan
   lebih tinggi (::v-deep menambah selektor induk), jadi tanpanya item aktif
   akan bertukar warna apabila tetikus sekadar melaluinya. */
.menu-active {
  background: var(--teal-700) !important;
}
.menu-active ::v-deep .v-list-item__title {
  color: #ffffff !important;
  font-weight: 700 !important;
}
.menu-active ::v-deep .v-icon {
  color: #ffffff !important;
}

/* ====================== KEADAAN REL (56px, ikon sahaja) ======================

   PUNCA GLITCH, dan sebab peraturan di bawah kelihatan sedikit luar biasa:
   Vuetify menganimasikan `width` laci selama 200ms, TETAPI menukar kelas
   `--mini-variant` SERTA-MERTA pada bingkai 0. Jadi apa-apa peraturan yang
   bergantung pada kelas itu bertukar ketika laci MASIH selebar 56px, kemudian
   susun aturnya "diperbetulkan" sepanjang animasi itu berjalan. Yang paling
   teruk dahulu ialah `white-space: nowrap -> normal`: tajuk Melayu yang panjang
   membalut kepada banyak baris pada 56px, ketinggian item membengkak, kemudian
   mengecut semula apabila lebar bertambah.

   PENYELESAIANNYA: kandungan diberi LEBAR TETAP 332px dan laci (overflow:
   hidden) sekadar mendedahkan lebih banyak daripadanya. Susun atur menjadi
   SAMA dalam kedua-dua keadaan, jadi tiada apa yang boleh menyusun semula —
   animasi lebar itu menjadi tingkap yang meluncur, bukan pengiraan semula.

   Itulah sebabnya tiada lagi peraturan `display: none` untuk teks jenama, teks
   pengguna atau suis: pada lebar tetap, kesemuanya duduk melepasi 56px dan
   terkerat secara semula jadi. Setiap peraturan yang DIBUANG ialah satu lompatan
   susun atur yang dibuang. */
.nav-drawer ::v-deep .v-navigation-drawer__content {
  width: 332px;
}
/* Semasa muatan, MATIKAN setiap peralihan pada laci dan segala isinya.
   Kelas ini digugurkan hanya selepas navsidebar() selesai (lihat siapBoot),
   jadi laci muncul terus dalam keadaan akhirnya: tiada luncuran lebar
   332->56, tiada kumpulan mengembang sendiri, tiada gerakan langsung.
   `!important` + `*` sengaja kasar — ia hidup hanya untuk seketika semasa
   boot, dan tugasnya ialah mengalahkan peralihan Vuetify sendiri. */
.nav-drawer--diam,
.nav-drawer--diam ::v-deep * {
  transition: none !important;
  animation: none !important;
}
/* Vuetify melukis garis 1px `rgba(0,0,0,.12)` menegak pada birai KANAN laci
   (.v-navigation-drawer__border — position:absolute; right:0; width:1px).
   Ia dimatikan di sini: laci sudah mempunyai pemisahnya sendiri (jenama teal,
   kad pengguna, dan latar putih yang bertentangan dengan kecerunan halaman),
   jadi garis kelabu itu hanya menambah birai kedua yang tidak dipinta —
   paling ketara ketika rel menguncup, di mana ia melekat pada ikon. */
.nav-drawer ::v-deep .v-navigation-drawer__border {
  display: none;
}
/* Penjajaran rel bergantung pada matematik ini — ketiga-tiganya berpusat pada
   x=28 (tengah rel 56px), jadi TIADA yang bergerak ketika menu mengembang:
     jubin jenama : padding-left  8 + lebar 40/2 = 28
     avatar       : padding-left  9 + lebar 38/2 = 28
     ikon menu    : padding 10+8   + lebar 20/2 = 28
   Ini menggantikan `justify-content: center` — pemusatan itu terpaksa DIMATIKAN
   apabila mengembang, dan pertukaran itulah yang membuat logo melompat. */
.nav-drawer.v-navigation-drawer--mini-variant .nav-eyebrow {
  /* `visibility`, bukan `display`: label ini menyumbang ~34px ruang menegak di
     atas item pertama. `display: none` akan meruntuhkan kotaknya, jadi ikon
     rumah melekat pada senarai — dan senarai melompat ketika rel mengembang. */
  visibility: hidden;
}
/* Semuanya di sini duduk melepasi x=56, jadi `overflow: hidden` laci SEPATUTNYA
   sudah cukup mengeratnya. Ia disembunyikan secara eksplisit kerana pada muatan
   PERTAMA ia sebenarnya menembus — garis selepas logo (x=58) dan nama profil
   (x=59) kelihatan sehingga hover pertama, kemudian berkelakuan betul.
   Bergantung pada kerat itu jelas tidak mencukupi, jadi elemen-elemen ini
   dikeluarkan terus daripada susun atur.

   Ini TIDAK menghidupkan semula glitch animasi yang dibetulkan sebelum ini:
   kesemuanya berada SELEPAS elemen yang kelihatan (jubin, avatar) dalam baris
   flex, dan elemen itu berlabuh dari KIRI — jadi membuang ini tidak
   menggerakkan walau satu piksel pun daripada apa yang kelihatan dalam rel.
   `__suis` dan `__keluar` memakai `margin-left: auto`, jadi ia pun tidak
   memindahkan apa-apa. */
.nav-drawer.v-navigation-drawer--mini-variant .nav-brand__text,
.nav-drawer.v-navigation-drawer--mini-variant .nav-brand__suis,
.nav-drawer.v-navigation-drawer--mini-variant .nav-user__text,
.nav-drawer.v-navigation-drawer--mini-variant .nav-user__keluar {
  display: none;
}
/* Satu-satunya perkara yang masih perlu disembunyikan: anak kumpulan yang
   terbuka berinden melepasi ikonnya, jadi hanya HUJUNG ikon itu menyelit ke
   dalam rel dan kelihatan seperti sampah. */
.nav-drawer.v-navigation-drawer--mini-variant .nav-sub {
  display: none;
}
/* Dalam keadaan rel, kumpulan INDUK mewarisi sorotan aktif.
   Sebabnya: `.menu-active` melekat pada pautan anak, dan anak itu berada di
   dalam `.nav-sub` yang baru sahaja disembunyikan di atas — jadi apabila
   halaman semasa berada di dalam submenu (cth. Kadar Respon), pil teal pekat
   itu turut hilang bersamanya dan rel langsung tidak menunjukkan lokasi
   pengguna. Warna teal pada ikon sahaja terlalu senyap untuk dibaca sebagai
   "anda di sini". Kekhususan (0,5,0) mengatasi peraturan :hover (0,4,0), jadi
   sorotan ini tidak lesap apabila tetikus melaluinya. */
.nav-drawer.v-navigation-drawer--mini-variant .nav-group--active ::v-deep .v-list-group__header {
  background: var(--teal-700);
}
.nav-drawer.v-navigation-drawer--mini-variant .nav-group--active ::v-deep .v-list-group__header .v-list-item__title,
.nav-drawer.v-navigation-drawer--mini-variant .nav-group--active ::v-deep .v-list-group__header .v-icon {
  color: #ffffff;
}
/* Tajuk kekal `normal` dalam KEDUA-DUA keadaan — pada lebar tetap ia sentiasa
   mempunyai 332px untuk dibalut, jadi tiada lagi pertukaran nowrap/normal dan
   tiada penyusunan semula pada bingkai 0. */
.nav-drawer ::v-deep .v-list-item__title {
  white-space: normal;
  /* Sama seperti `.nav-item__title`: lalai Vuetify `overflow: hidden` +
     `line-height: 1.2` mengerat kaki huruf menjunam pada saiz 18px. Diletak di
     sini juga supaya tajuk yang dijana Vuetify tanpa kelas kita turut selamat. */
  line-height: 1.45;
  overflow: visible;
}

/* ====================== MOD GELAP (menu sisi SAHAJA) ======================
   Palet daripada cabang `menu-design-2`. Bar atas SENGAJA tidak disentuh — ia
   kekal teal dalam kedua-dua mod; suis ini hanya menukar menu.

   Peraturan ini diletak SELEPAS peraturan cerah dengan sengaja: kekhususannya
   sama (0,2,0), jadi susunan sumberlah yang menentukan pemenang. Mengalihkannya
   ke atas akan mematikan mod gelap secara senyap.

   Kepala jenama turut menjadi gelap: latarnya ditetapkan `transparent` supaya
   kecerunan `__content` menembusinya — bukan dicat semula dengan warna solid,
   yang akan menghasilkan jahitan kelihatan di tempat kecerunan itu bermula.
   Hanya jubin logo yang kekal putih. */
.nav-drawer--gelap ::v-deep .v-navigation-drawer__content {
  background: linear-gradient(180deg, #01342e 0%, #01463e 42%, #026254 100%);
}
.nav-drawer--gelap .nav-brand {
  background: transparent;
  border-bottom-color: rgba(255, 255, 255, .10);
}
.nav-drawer--gelap .nav-brand__rule {
  background: rgba(255, 255, 255, .18);
}
/* Teal pekat mod cerah tidak boleh dibaca di atas kecerunan gelap — mint pula
   memberi 9.2:1 dan mengekalkan tajuk itu tebal serta berwarna. */
.nav-drawer--gelap .nav-brand__sub {
  color: var(--mint);
}
.nav-drawer--gelap .nav-brand__suis {
  color: rgba(190, 240, 232, .70) !important;
}
.nav-drawer--gelap .nav-user {
  background: rgba(255, 255, 255, .07);
  border-top-color: rgba(255, 255, 255, .10);
}
.nav-drawer--gelap .nav-user__avatar {
  background: var(--teal-400);
}
.nav-drawer--gelap .nav-user__name {
  color: #ffffff;
}
.nav-drawer--gelap .nav-user__role {
  color: var(--mint);
}
.nav-drawer--gelap .nav-user__keluar {
  color: rgba(190, 240, 232, .70) !important;
}
.nav-drawer--gelap .nav-user__keluar:hover {
  color: var(--mint) !important;
}
.nav-drawer--gelap .nav-eyebrow {
  color: rgba(127, 233, 221, .55);
}
.nav-drawer--gelap .nav-list ::v-deep .v-list-item:hover {
  background: rgba(255, 255, 255, .08);
}
.nav-drawer--gelap .nav-item__icon .v-icon {
  color: rgba(190, 240, 232, .55);
}
.nav-drawer--gelap .nav-item__title {
  color: rgba(255, 255, 255, .82);
}
.nav-drawer--gelap .nav-group ::v-deep .v-list-group__header__append-icon .v-icon {
  color: rgba(255, 255, 255, .38);
}
.nav-drawer--gelap .nav-group--active ::v-deep .v-list-group__header .nav-item__title,
.nav-drawer--gelap .nav-group--active ::v-deep .v-list-group__header .nav-item__icon .v-icon {
  color: var(--mint);
}
.nav-drawer--gelap .nav-sub {
  border-left-color: rgba(255, 255, 255, .13);
}
/* Item aktif: pil MINT dengan teks gelap, bukan pil #0EA5A4 + teks putih yang
   dipakai reka bentuk 2. Gabungan reka bentuk 2 itu hanya 3.03:1 — gagal WCAG
   AA. Mint di atas teks #01342e memberi 9.2:1 dan lebih menonjol di atas
   kecerunan gelap. Teal pekat mod cerah pula tidak boleh dipakai di sini: ia
   hampir sewarna dengan latar gelap dan item aktif akan lenyap. */
.nav-drawer--gelap .menu-active {
  background: var(--mint) !important;
}
.nav-drawer--gelap .menu-active ::v-deep .v-list-item__title,
.nav-drawer--gelap .menu-active ::v-deep .v-icon {
  color: #01342e !important;
}
/* Sorotan rel yang sama, dalam palet gelap. Teal pekat mod cerah tidak boleh
   dipakai di sini — nilainya hampir sama dengan latar gelap dan sorotan itu
   akan lenyap. Mesti selepas peraturan rel mod cerah (kekhususan sama, jadi
   susunan sumber yang menentukan). */
.nav-drawer--gelap.v-navigation-drawer--mini-variant .nav-group--active ::v-deep .v-list-group__header {
  background: var(--mint);
}
.nav-drawer--gelap.v-navigation-drawer--mini-variant .nav-group--active ::v-deep .v-list-group__header .v-list-item__title,
.nav-drawer--gelap.v-navigation-drawer--mini-variant .nav-group--active ::v-deep .v-list-group__header .v-icon {
  color: #01342e;
}
</style>